import { gql } from 'apollo-angular';

export const deviceListQuery = gql`
  query DeviceList($includeGateway: Boolean, $widgetType: String) {
    deviceList(includeGateway: $includeGateway, widgetType: $widgetType) {
      id
      name
      status
      property {
        name
        id
      }
      groups {
        name
        id
      }
      category {
        name
        id
      }
      communicationProtocol {
        name
        id
      }
    }
  }
`;

export const deviceSelectOptionsQuery = gql`
  query DeviceSelectOptions {
    deviceList {
      id
      name
    }
  }
`;

export const deviceSelectOptionsWImageQuery = gql`
  query DeviceSelectOptionsWImage($categoryId: ID, $includeGateway: Boolean = false) {
    deviceList(categoryId: $categoryId, includeGateway: $includeGateway) {
      id
      name
      imgUrl
    }
  }
`;

export const deviceListDetailsQuery = gql`
  query DeviceListDetails($id: ID!, $from: Int!, $to: Int!) {
    deviceEvents(id: $id, from: $from, to: $to) {
      total
      items {
        ... on Event {
          id
          status
          lastUpdate
          condition
        }
      }
    }
    deviceDetails(id: $id) {
      name
      manufacturer
      model
      serialNumber
      smallImgUrl
      id
    }
  }
`;

export const deviceDetailsQuery = gql`
  query DeviceDetails($id: ID!) {
    deviceDetails(id: $id) {
      id
      imgUrl
      lastUpdate
      manufacturer
      model
      online
      name
      serialNumber
      category {
        id
        name
      }
      property {
        name
      }
      groups {
        name
      }
      # automations {
      #   name
      # }
      alarms {
        name
      }
      currentConsumption {
        value
        unit
      }
      highestPeakLoadCurrentMonth {
        value
        unit
      }
      averageMonthlyConsumption {
        value
        unit
      }
      averageCostPerMonth {
        value
        unit
      }
      firmware {
        id
        version
        releaseDate
        updateAvailable
        latestVersion
      }
      port1State
      port2State
      port3State
      port4State
      tripStatus
      toggleStatus
      mcbTemperature
    }
  }
`;

export const deviceEventsQuery = gql`
  query DeviceEvents(
    $id: ID!
    $from: Int!
    $to: Int!
    $fromDate: AWSDateTime
    $toDate: AWSDateTime
    $status: Status
    $userId: ID
  ) {
    deviceEvents(
      id: $id
      from: $from
      to: $to
      fromDate: $fromDate
      toDate: $toDate
      status: $status
      userId: $userId
    ) {
      total
      items {
        ... on Event {
          id
          status
          lastUpdate
          condition
          lastUpdateBy {
            imgUrl
            name
            lastName
          }
        }
      }
    }
  }
`;

export const deviceEventsHistoryExportQuery = gql`
  query DeviceEventHistoryExport(
    $id: ID!
    $fromTs: AWSDateTime
    $toTs: AWSDateTime
  ) {
    deviceEventHistoryExport(id: $id, fromTs: $fromTs, toTs: $toTs) {
      id
      filename
      contentType
      size
      content
    }
  }
`;
export const toggleDevicePowerMutation = gql`
  mutation ToggleDevicePower($id: ID!, $power: Boolean!) {
    toggleDevicePower(id: $id, power: $power) {
      id
      online
      lastUpdate
    }
  }
`;

export const updateDeviceChargingSpeedMutation = gql`
  mutation UpdateDeviceChargingSpeed($id: ID!, $speed: Int!) {
    updateDeviceChargingSpeed(id: $id, speed: $speed) {
      id
      chargingSpeed
      lastUpdate
    }
  }
`;

export const updateDeviceDetailsMutation = gql`
  mutation UpdateDeviceDetails(
    $id: ID!
    $name: String!
    $manufacturer: String!
    $model: String!
    $location: String
    $serialNumber: String!
    $serviceContract: String
    $installationDate: AWSDateTime
    $coordinates: CoordinatesInput
    $categoryId: ID!
  ) {
    updateDeviceDetails(
      id: $id
      name: $name
      manufacturer: $manufacturer
      model: $model
      location: $location
      serialNumber: $serialNumber
      serviceContract: $serviceContract
      installationDate: $installationDate
      coordinates: $coordinates
      categoryId: $categoryId
    ) {
      id
      name
      manufacturer
      model
      location
      serialNumber
      serviceContract
      installationDate
      coordinates {
        lat
        lng
      }
      lastUpdate
      category {
        id
        name
      }
    }
  }
`;

export const groupListQuery = gql`
  query GroupList($includeConsumption: Boolean) {
    groupList (includeConsumption: $includeConsumption) {
      id
      name
      consumption
      properties {
        id
        name
      }
      description
      assets {
        __typename
        ... on PropertyWithConsumption {
          id
          name
          imgUrl
          consumption
        }
        ... on Device {
          id
          name
          imgUrl
          property {
            id
            name
          }
          consumption
        }
      }
    }
  }
`;

export const deleteGroupMutation = gql`
  mutation DeleteGroup($id: ID!) {
    deleteGroup(id: $id) {
      id
      name
    }
  }
`;

export const assetListByTypeQuery = gql`
  query AssetListByType {
    assetListByType {
      devices {
        id
        name
        imgUrl
      }
      properties {
        id
        name
        imgUrl
      }
    }
  }
`;

export const createGroupMutation = gql`
  mutation CreateGroup(
    $name: String!
    $assets: [AssetInput!]!
    $description: String!
  ) {
    createGroup(name: $name, assets: $assets, description: $description)
  }
`;

export const updateGroupMutation = gql`
  mutation UpdateGroup(
    $id: ID!
    $name: String!
    $assets: [AssetInput!]!
    $description: String!
  ) {
    updateGroup(
      id: $id
      name: $name
      assets: $assets
      description: $description
    )
  }
`;
